import type { TouchField } from '../input/TouchField';

/**
 * Tracks the transition into / out of "attract mode" — N seconds with no
 * touch. Sketches read `t` (seconds of continuous idle, 0 while engaged) to
 * drive self-animation, e.g. The Watcher slowly scanning the room.
 */
export class IdleTimer {
  /** Seconds of continuous idle (0 when a touch is active). */
  t = 0;
  /** True once past the threshold. */
  idle = false;

  constructor(
    private readonly input: TouchField,
    private readonly threshold = 8,
  ) {}

  update(): void {
    this.t = this.input.active ? 0 : this.input.idleSeconds();
    this.idle = this.t >= this.threshold;
  }
}
